import { Injectable } from "@angular/core";

declare var _paq;  // our external tracking variable

@Injectable()
export class MetricsService {
    constructor() {

    }
    public trackEvent(category, action, name?:string, value?:string) {
        let data = ['trackEvent', category, action];
        if (name) {
            data.push(name);
        }
        if (value !== undefined) {
            data.push(value);
        }
        _paq.push(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/metrics.service.ts